/**
 * This is the account routes configuration.
 * Only configure routes in this file.
 * @memberOf Account Module
 * @namespace Account Routes
 */
import accountTemplate from './account.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf Account Module.Account Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the account state and assign the template and controller. */
    $stateProvider
		.state('login.account', {
			url: '',
			template: accountTemplate,
			controller: 'accountController',
			controllerAs: 'accountController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/account/account.route.js